export const DATE_REGEX = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/[12][0-9]{3}$/;

export const ONLY_STRING_REGEX = new RegExp('^[A-Za-z ]+$');
